import { LanguageLocale, LanguageURL } from "../constants";

export const LanguageURLToLocaleMap: Record<LanguageURL, LanguageLocale> = {
  [LanguageURL.EN]: LanguageLocale.USen,
  [LanguageURL.JP]: LanguageLocale.JAjp,
  [LanguageURL.VI]: LanguageLocale.VIvn,
  [LanguageURL.ZH]: LanguageLocale.ZHcn
}
